
import { useState, useEffect, useCallback } from 'react';
import { getSharedTechnique } from '@/services/sharing/sharedTechniqueService';
import type { Database } from '@/integrations/supabase/types';
import { toast } from '@/hooks/use-toast';

export function useSharedTechnique(shareId: string | undefined) {
  type SharedTechniqueRow = Database['public']['Tables']['shared_techniques']['Row'];

  const [sharedTechnique, setSharedTechnique] = useState<SharedTechniqueRow | null>(null);
  const [loading, setLoading] = useState(true);
  
  const loadSharedTechnique = useCallback(async (id: string) => {
    setLoading(true);
    
    try {
      const technique = await getSharedTechnique(id);
      setSharedTechnique(technique);
    } catch (error) {
      console.error('Error loading shared technique:', error);
      toast({
        title: "Error loading shared technique",
        description: "The shared technique couldn't be loaded",
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (shareId) {
      loadSharedTechnique(shareId);
    }
  }, [shareId, loadSharedTechnique]);

  return { sharedTechnique, loading };
}
